
// src/components/trading/StewieQuantStrategyProvider.tsx
import React, { useState } from 'react';
import { Strategy } from './types';
import StewieQuantAlgorithm from './StewieQuantAlgorithm';
import { useToast } from "@/hooks/use-toast";
// Import the correct component
import EnhancedStrategyDialog from './EnhancedStrategyDialog';

interface StewieQuantStrategyProviderProps {
  onAddStrategy: (strategy: any) => void;
  activeStrategy: Strategy | null;
}

const StewieQuantStrategyProvider: React.FC<StewieQuantStrategyProviderProps> = ({
  onAddStrategy,
  activeStrategy
}) => {
  const { toast } = useToast();
  const [isExpanded, setIsExpanded] = useState(false);
  // State to control the EnhancedStrategyDialog visibility
  const [showEnhancedDialog, setShowEnhancedDialog] = useState(false);
  // State to hold data generated by StewieQuant before user confirmation
  const [pendingStrategyData, setPendingStrategyData] = useState<Partial<Strategy> | null>(null);

  const handleCreateStrategy = (strategyData: any) => {
    if (!strategyData) {
      toast({
        title: "Strategy Generation Failed",
        description: "StewieQuant could not generate strategy parameters.",
        variant: "destructive"
      });
      return;
    }
    // Store the generated data and open the Enhanced dialog for review/customization
    setPendingStrategyData(strategyData);
    setShowEnhancedDialog(true);
  };

  const handleStrategySubmit = (finalData: any) => {
    // Pass the final, potentially customized data to the parent
    onAddStrategy(finalData);

    toast({
      title: "Strategy Created",
      description: `StewieQuant strategy "${finalData.name}" has been created.`,
    });

    // Close the dialog and clear pending data
    setShowEnhancedDialog(false);
    setPendingStrategyData(null);
  };

  const handleFetchMarketData = (symbols: any[]) => {
    console.log('Provider: Fetching market data for symbols:', symbols);
    // Implement actual data fetching logic if needed at this level,
    // or rely on the hook used within StewieQuantAlgorithm/dashboard.
  };

  return (
    <>
      <StewieQuantAlgorithm
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        // Pass the handler that opens the *Enhanced* dialog
        onCreateStrategy={handleCreateStrategy}
        activeStrategy={activeStrategy}
        onFetchMarketData={handleFetchMarketData}
      />

      {/* Use EnhancedStrategyDialog, controlled by its own state */}
      <EnhancedStrategyDialog
        open={showEnhancedDialog}
        onOpenChange={setShowEnhancedDialog}
        onSubmit={handleStrategySubmit} // Pass the final submit handler
        isStewieQuant={true} // Indicate this is for StewieQuant
        initialData={pendingStrategyData} // Pass the data generated by the algorithm
      />
    </>
  );
};

export default StewieQuantStrategyProvider;
